module.exports = __webpack_public_path__ + "static/green-couch-nav-227091f8de8d0c5341efbe52ba3dca52.jpeg";